// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__7r9G5","title":"ClientInsurance_title__3ErSg","itemText":"ClientInsurance_itemText__EuvLg"};